var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 0.667877C3.94996 0.667877 0.666626 3.95121 0.666626 8.00121C0.666626 12.0512 3.94996 15.3345 7.99996 15.3345C12.05 15.3345 15.3333 12.0512 15.3333 8.00121C15.3333 3.95121 12.05 0.667877 7.99996 0.667877ZM11.1786 6.76121C11.2372 6.69431 11.2817 6.61637 11.3097 6.53199C11.3376 6.44761 11.3485 6.35849 11.3415 6.26987C11.3345 6.18125 11.3099 6.09492 11.269 6.01596C11.2282 5.93701 11.1719 5.86701 11.1037 5.81011C11.0354 5.7532 10.9564 5.71052 10.8714 5.68459C10.7863 5.65865 10.697 5.64999 10.6085 5.6591C10.5201 5.66821 10.4344 5.69491 10.3565 5.73763C10.2785 5.78036 10.2099 5.83824 10.1546 5.90788L7.28796 9.34721L5.80463 7.86321C5.67889 7.74177 5.51049 7.67458 5.33569 7.6761C5.16089 7.67761 4.99369 7.74773 4.87008 7.87133C4.74647 7.99494 4.67636 8.16215 4.67484 8.33694C4.67332 8.51174 4.74052 8.68014 4.86196 8.80588L6.86196 10.8059C6.92746 10.8713 7.00589 10.9224 7.09224 10.9559C7.17858 10.9894 7.27096 11.0045 7.36347 11.0003C7.45599 10.9961 7.54661 10.9727 7.62957 10.9315C7.71252 10.8903 7.78599 10.8323 7.84529 10.7612L11.1786 6.76121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRightIcon);
export default __webpack_public_path__ + "static/media/circleRightIcon.410e714b06a0f44a1633aa82eb48c93f.svg";
export { ForwardRef as ReactComponent };